module.exports = "/_next/static/images/db9fba9220eb4dea3ca70df28dcd12dd-choose-money-box.png";